import { useState } from "react";
import { MdModeEdit } from "react-icons/md";
import classes from "./DatePicker.module.css";
import {
  getLastMonthDates,
  getLastWeekDates,
  getMonthName,
} from "../../util/ReportGeneration/getLastWeekMonthDates";

function calculateDaysGapFromDateTillToday(date) {
  // this function accepts a date string and calculates how many days gap is from that date
  // till today.

  let d2 = null;
  if (typeof date == "string") {
    // we convert string to date object
    let arr = date.split("/");

    d2 = Date.parse(`${arr[1]}/${arr[0]}/${arr[2]}`);
    d2 = new Date(d2);
  }
  let d1 = new Date();
  if (d2 == null) d2 = new Date(date);

  let diff = Date.parse(d1) - Date.parse(d2);

  let diffOfDays = Math.floor(diff / (1000 * 3600 * 24));
  return diffOfDays;
}

function isDataSufficientToCreateReport(date) {
  // this function fetches mainDataRange and
  // checks is mainDataRange is smaller than farthest date given
  // then we return false and user need to fetch more data.
  let mainDataRange = JSON.parse(sessionStorage.getItem("mainDataTimeRange"));

  let farthestDay = calculateDaysGapFromDateTillToday(date);

  if (farthestDay <= mainDataRange)
    return {
      status: true,
      dataAvailable: mainDataRange,
      DataRequired: farthestDay,
    };
  else
    return {
      status: false,
      dataAvailable: mainDataRange,
      DataRequired: farthestDay,
    };
}

export default function DatePicker({ setReportDate, setFileName }) {
  // this ReportDate state variable will be array of 2 element date from , and date till.
  const [date, setDate] = useState([["dd/mm/yyyy"], ["dd/mm/yyyy"]]);

  const [error, setError] = useState("");

  const [chooseDate, setChooseDateMode] = useState(true);

  //check if date duration set here exceeds mainDataRange then we demand user to fetch more data
  // from home page.

  // what should be display in date input labels.
  let displayDates = JSON.parse(localStorage.getItem("reportDates"));
  if (displayDates == null) displayDates = ["", ""];

  function dateSaveHandler() {
    //console.log("pressed dateSaveHandler");

    //console.log(date);
    setError("");
    // processing From date .
    let enteredFromDate = document.getElementById("fromDateEntered").value;

    let enteredFromDateArr = enteredFromDate.split("/");
    let fromDateMilliseconds = Date.parse(
      `${enteredFromDateArr[1]}/${enteredFromDateArr[0]}/${enteredFromDateArr[2]}`
    );

    let dateFrom = new Date(fromDateMilliseconds);

    // processing Till Date

    let enteredTillDate = document.getElementById("tillDateEntered").value;
    let enteredTillDateArr = enteredTillDate.split("/");

    let tillDateMilliseconds = Date.parse(
      `${enteredTillDateArr[1]}/${enteredTillDateArr[0]}/${enteredTillDateArr[2]}`
    );

    // setting file name for pdf report
    let fName = "";
    let diffOfDays =
      (tillDateMilliseconds - fromDateMilliseconds) / (1000 * 60 * 60 * 24) + 1;
    //console.log(diffOfDays);
    fName = `${enteredFromDate}(${diffOfDays}days)`;
    //console.log(fName);
    let name = fName.replaceAll("/", "-");
    setFileName(name);

    // check if fromDate is smaller than Till date then show error

    if (fromDateMilliseconds > tillDateMilliseconds) {
      setError("From Date cannot be Later than Till Date.");
      return;
    }
    let dateTill = new Date(tillDateMilliseconds + 86399000);
    // we need to include whole day as well til 11:59 :59 pm

    let t1 = dateTill.toLocaleDateString("en-in");

    let dateArray = [
      dateFrom.toLocaleDateString("en-in"),
      dateTill.toLocaleDateString("en-in"),
    ];

    localStorage.setItem(
      "reportDates",
      JSON.stringify([enteredFromDate, enteredTillDate])
    );
    //CHekcing if user enetered invalid date
    // If the date object is invalid it
    // will return 'NaN' on getTime()
    // and NaN is never equal to itself
    if (
      dateFrom.getTime() != dateFrom.getTime() ||
      dateTill.getTime() != dateTill.getTime()
    ) {
      setDate(dateArray);
      setError("Invalid Date Entered");
    } else {
      if (isDataSufficientToCreateReport(dateFrom).status) {
        setReportDate([dateFrom, dateTill]);
        setDate(dateArray);
        setChooseDateMode(false);
      } else {
        setError(
          `Please Fetch More Data on Home Page. Data Required for ${
            isDataSufficientToCreateReport(dateFrom).DataRequired
          } days older. but fetched for Only ${
            isDataSufficientToCreateReport(dateFrom).dataAvailable
          } days`
        );
      }
    }
  }
  function dateButtonHandler(e) {
    
    setError("");
    let id = e.target.id;

    if (id == "week") {
      let arr = getLastWeekDates();

      let dateStr = [
        arr[0].toLocaleDateString("en-in"),
        arr[1].toLocaleDateString("en-in"),
      ];

      // setting the file name of pdf report
      let fName1 = `W ${dateStr[0]}`;
      let fName = fName1.replaceAll("/", "-");
      //console.log(fName);
      setFileName(fName);
      if (isDataSufficientToCreateReport(arr[0]).status) {
        setDate(dateStr);
        setReportDate([arr[0], arr[1]]);
        setChooseDateMode(false);
      } else {
        setDate(dateStr);
        setError(
          `Please Fetch More Data on Home Page. Data Required for ${
            isDataSufficientToCreateReport(arr[0]).DataRequired
          } days but fetched for Only ${
            isDataSufficientToCreateReport(arr[0]).dataAvailable
          } days`
        );
      }
    }
    if (id == "month") {
      let arr = getLastMonthDates();

      let dateStr = [
        arr[0].toLocaleDateString("en-in"),
        arr[1].toLocaleDateString("en-in"),
      ];

      // getting month name for file name
      let monthName = getMonthName(arr[0]);

      // getting year to add in file name;
      let year = arr[0].getFullYear();
      //console.log(year);
      //console.log(monthName);
      // setting the file name of pdf reports
      setFileName(`${monthName} ${year}`);
      if (isDataSufficientToCreateReport(arr[0]).status) {
        setDate(dateStr);
        setReportDate([arr[0], arr[1]]);
        setChooseDateMode(false);
      } else {
        setDate(dateStr);
        setError(
          `Please Fetch More Data on Home Page. Data Required for ${
            isDataSufficientToCreateReport(arr[0]).DataRequired
          } days but fetched for Only ${
            isDataSufficientToCreateReport(arr[0]).dataAvailable
          } days`
        );
      }
    }
  }

  function changeDatePickerMode() {
    setChooseDateMode(true);
  }

  let chosenDateComponent = (
    <>
      <div className={classes.chosenDateContainer}>
        <div> {`${date[0]} - ${date[1]}`}</div>{" "}
        <div
          className={classes.chosenDateContainerIcon}
          onClick={() => {
            changeDatePickerMode();
          }}
        >
          <MdModeEdit />
        </div>
      </div>
    </>
  );

  let chooseDateComponent = (
    <div className={classes.container}>
      <div className={classes.errorMessage}>
        <p>{error}</p>
      </div>
      <p>Enter Dates</p>
      <div className={classes.manualDatesContainer}>
        <div className={classes.FromTill}>
          <p>From</p>
          <p>Till</p>
        </div>
        <div className={classes.dateInputContainer}>
          <input
            type="text"
            placeholder="dd/mm/yyyy"
            maxLength={10}
            autoFocus
            defaultValue={displayDates[0]}
            id={"fromDateEntered"}
          />{" "}
          <br />
          <input
            type="text"
            placeholder="dd/mm/yyyy"
            maxLength={10}
            defaultValue={displayDates[1]}
            id={"tillDateEntered"}
          />
        </div>
      </div>
      <div
        className={classes.Button}
        onClick={() => {
          dateSaveHandler();
        }}
      >
        Save
      </div>

      <p>OR</p>
      <div className={classes.dateButtonsContainer}>
        <div
          className={classes.Button}
          id={"week"}
          onClick={(e) => dateButtonHandler(e)}
        >
          Last Week
        </div>
        <div
          className={classes.Button}
          id={"month"}
          onClick={(e) => dateButtonHandler(e)}
        >
          Last Month
        </div>
      </div>

      {/* <div className={classes.datePreview}>
        <p>
          Date - {date[0]} - {date[1]}
        </p>
      </div> */}
    </div>
  );

  return chooseDate ? chooseDateComponent : chosenDateComponent;
}
